import { object, string } from 'yup'

import { i18nErrorCodes } from '../form-utils'

const { required } = i18nErrorCodes

export default object().shape({
  date: string().required(required),
  time: string().required(required),
})

export const emptyAppointment = {
  date: '',
  time: '',
}



// WEBPACK FOOTER //
// ./src/components/forms/schemas/appointment.schema.ts